// export const serverUrl = "http://10.10.106.73:8080";
export const serverUrl = "https://starmines-server.palsar.io";
// export const serverUrl =
//   "https://star-mines-server-dot-eshkol-224009.ew.r.appspot.com";
export const arrayLength = 25;
export const maxPercentageOnWinOrLoss = 1000;
export const minPercentageOnWinOrLoss = 0;
